export const types = {
    ENCODE: "ENCODE",
    DECODE: "DECODE"
};